import React, { useState } from 'react'

const BonusMaior = () => {
    const [showAnimated, setShowAnimated] = useState([])

    const handleClick = (index) => {
        if (!showAnimated.includes(index)) {
            setShowAnimated([...showAnimated, index])
        }
    }

    return (
        <>
            <div className='bomba-bonus d-flex justify-content-center align-items-center h-100'>
                <div className='position-relative'>
                    <img className='img-fluid ' src="assets/img/bomba/bonusMaior/Bonus-maior.png" alt="" />
                    <div className='img-animation-content'>
                        <div className='bonus-maior-images'>
                            {[0, 1, 2, 3, 4].map((index) => (
                                <span key={index}>
                                    {!showAnimated.includes(index) && <img className='img-fluid' src="assets/img/bomba/bonusMaior/bonus-maior.gif" alt="" onClick={() => handleClick(index)} style={{ cursor: 'pointer' }} />}
                                    {showAnimated.includes(index) && <img className='img-fluid' src="assets/img/bomba/bonusMaior/bomba-animated.gif" alt="" />}
                                </span>
                            ))}
                        </div>
                        <span className='bonus-text-content'>230</span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BonusMaior